import analyst from './analyst'
import ga4 from './ga4'
import parentEvents from './parentEmitter'
// const { isEnabled = true } = config.analytics

// setAnalyticsCollectionEnabled(firebaseAnalytics, isEnabled)

function identify(user_id: string, params: { name: string }) {
  analyst.identify(user_id, params)
}

function sendEvent(
  event: string,
  params?: {
    [key: string]: any
  },
  paramsPrivate?: {
    [key: string]: any
  },
) {
  analyst.track(event, { ...params, ...paramsPrivate })
  if (process.env.NODE_ENV !== 'production') return null

  ga4.event(event, params)
  parentEvents.sendAnalyticsEventToParent({
    event,
    params,
  })
}

export default {
  sendEvent,
  identify,
}
